import auth0module from 'auth0-js';

export default (bottle) => {
  bottle.factory('jsonString', () => (obj) => {
    try {
      return JSON.stringify(obj);
    } catch (err) {
      return `${obj}`;
    }
  });

  // might not be needed
  bottle.factory('auth0', auth0module);

  bottle.factory('WebAuth', () => auth0module.WebAuth);

  bottle.factory('window', () => window);

  bottle.factory('document', () => document);

  bottle.factory('now', () => () => Date.now());

  bottle.factory('CustomEvent', ({ window, document }) => {
    function CustomEvent(event, params = { bubbles: false, cancelable: false, detail: undefined }) {
      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    }
    if (window) {
      if (window.Event) {
        CustomEvent.prototype = window.Event.prototype;

        if (window.Event && typeof window.CustomEvent !== 'function') {
          CustomEvent.prototype = window.Event.prototype;
        }

        // eslint-disable-next-line no-param-reassign
        window.CustomEvent = CustomEvent;
      }
    }
    return CustomEvent;
  });

  bottle.factory('clearHash', ({ window }) => {
    if (window && window.location) {
      // eslint-disable-next-line no-param-reassign
      window.location.hash = '';
    }
  });

  bottle.constant('SESSION', 'session');
  bottle.constant('SESSION_END', 'sessionend');
  bottle.constant('SESSION_START', 'sessionstart');
  bottle.constant('SESSION_ERROR', 'sessionerror');
  bottle.constant('CALLBACK_ERROR', 'callbackerror');
};



// WEBPACK FOOTER //
// ./src/utils.js